import { DonationCategory } from "../Payment/constant";

export const sadhuBhojan = [
  "It is mentioned in Padma Purana that",
  "ārādhanānāṁ sarveṣāṁ viṣṇor ārādhanaṁ param",
  "tasmāt parataraṁ devi tadīyānāṁ samarcanam",
  "Of all types of services, service of Lord Krishna is best, and better than the worship of Lord Viṣṇu is the service of His devotee, the Vaiṣṇava.",
  "Feed the Sadhus of ISKCON Vallabh Vidyanagar and get the blessings of Lord Krishna for your family.",
];
export const donationCategories: DonationCategory[] = [
  {
    title: "SadhuBhojan",
    donations: [
      { id: 1, title: "Sponsor 1 day prasadam for 10 sadhus", amount: 2000 },
      { id: 2, title: "Sponsor 1 day prasadam for 25 sadhus", amount: 5000 },
      { id: 3, title: "Sponsor 1 day prasadam for 50 sadhus", amount: 10000 },
      { id: 4, title: "Sponsor 1 day prasadam for 75 sadhus", amount: 15000 },
      { id: 5, title: "Sponsor 1 day prasadam for 100 sadhus", amount: 20000 },
      {
        id: 6,
        title: "Sponsor 1 day FEAST prasadam for all sadhus",
        amount: 31000,
      },
      {
        id: 7,
        title: "Sponsor 2 days FEAST prasadam for all sadhus",
        amount: 61000,
      },
      {
        id: 8,
        title: "Sponsor 3 days FEAST prasadam for all sadhus",
        amount: 91000,
      },
      {
        id: 9,
        title: "Sponsor 5 days FEAST prasadam for all sadhus",
        amount: 151000,
      },
      {
        id: 10,
        title: "Sponsor 7 days FEAST prasadam for all sadhus",
        amount: 211000,
      },
      {
        id: 11,
        title: "Sponsor 10 days FEAST prasadam for all sadhus",
        amount: 300000,
      },
      {
        id: 12,
        title: "Sponsor 15 days FEAST prasadam for all sadhus",
        amount: 450000,
      },
    ],
  },
];
